import without from 'lodash/without';
class SyncHook {
    callbacks = [];
    constructor(){
        this.callbacks = [];
    }
    add(fn) {
        this.callbacks = [
            ...this.callbacks,
            fn
        ];
    }
    remove(fn) {
        this.callbacks = without(this.callbacks, fn);
    }
    clear() {
        this.callbacks = [];
    }
    exec(thisArg, ...args) {
        this.callbacks.forEach((x)=>{
            x.call(thisArg, ...args);
        });
    }
    execReduce(initialValue, ...args) {
        return this.callbacks.reduce((reduction, fn)=>{
            return fn(reduction, ...args);
        }, initialValue);
    }
}
export default SyncHook;
